import { useMemo } from "react";
import { CDN_BASE_URL } from "../utility/constants";
import { withPrefix } from "gatsby";
const DEV_PATH_PREFIX = process.env.PATH_PREFIX ?? "";

const useRepairabilityIndexImg = (repairabilityIndex, lineId) => {
  const repairabilityIndexImg = useMemo(() => {
    if (!repairabilityIndex) return null;
    const repairabilityIndexReplaced = repairabilityIndex?.replace(",", ".");
    const siteLocale = DEV_PATH_PREFIX || withPrefix("/");
    let index;
    switch (repairabilityIndexReplaced >= 0 && repairabilityIndexReplaced <= 10) {
      case repairabilityIndexReplaced >= 0 && repairabilityIndexReplaced <= 1.9:
        index = "0-1.9";
        break;
      case repairabilityIndexReplaced >= 2 && repairabilityIndexReplaced <= 3.9:
        index = "2-3.9";
        break;
      case repairabilityIndexReplaced >= 4 && repairabilityIndexReplaced <= 5.9:
        index = "4-5.9";
        break;
      case repairabilityIndexReplaced >= 6 && repairabilityIndexReplaced <= 7.9:
        index = "6-7.9";
        break;
      case repairabilityIndexReplaced >= 8 && repairabilityIndexReplaced <= 10:
        index = "8-10";
        break;
      default:
        break;
    }

    if (index && siteLocale.includes("fr_FR") && (lineId === 777 || lineId === 888)) {
      return `${CDN_BASE_URL}/durability-index/${index}.svg`;
    }

    return index ? `${CDN_BASE_URL}/repairability-index/${index}.svg` : null;
  }, [repairabilityIndex, lineId]);

  return repairabilityIndexImg;
};

export default useRepairabilityIndexImg;
